module.exports = __webpack_public_path__ + "img/odocs_logo_mic_ro.ef92f61d.8e51eb48.png";